import commerce from '@lib/api/commerce'
import { Layout, DynamicComponent } from '@components/common'
import type { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { SbEditableContent } from 'storyblok-react'
import Storyblok, { useStoryblok } from '@lib/storyblok'
import getDetailsFromStory from '@lib/storyblokBigCommerce'
import { BlogPostStory, fetchPosts } from '@lib/blog'
import React, { useEffect, useState } from 'react'
import { Prelaunch, ThreeUpBlogComponent } from '@components/home'

export async function getStaticProps({
  preview,
  locale,
  locales,
}: GetStaticPropsContext) {
  const config = commerce.getConfig({ locale, locales })

  const sbParams = {
    version: 'draft',
  }

  const {
    data: { story },
  } = await Storyblok.get('cdn/stories/home', sbParams)
  const copyOfStory = Object.assign({}, story)
  const fullProducts = await getDetailsFromStory({ story, config, preview })
  copyOfStory.content = fullProducts

  return {
    props: {
      story: copyOfStory,
    },
    revalidate: 60,
  }
}

export default function Home({
  story,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const liveStory = useStoryblok(story)
  const [posts, setPosts] = useState<BlogPostStory[]>([])

  useEffect(() => {
    fetchPosts({
      perPage: 3,
      page: 1,
      storyblokParams: {
        with_tag: 'homepage',
        resolve_relations: ['blogpost.author'],
      },
    }).then((res) => {
      const blogPosts = res.data.stories
      setPosts(blogPosts)
    })
  }, [])

  const components = liveStory.content.body.map((blok: SbEditableContent) => {
    return <DynamicComponent blok={blok} key={blok._uid} />
  })

  if (process.env.NEXT_PUBLIC_PRELAUNCH) {
    return <Prelaunch />
  }

  return (
    <div>
      {components}
    </div>
  )
}

if (!process.env.NEXT_PUBLIC_PRELAUNCH) {
  Home.Layout = Layout
}
